module.exports = __webpack_public_path__ + "media/aligator_m.9b301ee2.mp3";